import { render, staticRenderFns } from "./EChatButton.vue?vue&type=template&id=5a32d2e3"
import script from "./EChatButton.vue?vue&type=script&lang=ts"
export * from "./EChatButton.vue?vue&type=script&lang=ts"
import style0 from "./EChatButton.vue?vue&type=style&index=0&id=5a32d2e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports